import React from 'react';
import { Tooltip } from 'antd';
import useTranslation from '../../hooks/translation/useTranslation';

function WagonTable({ className = 'wagon-feature', style = {} }) {
  const { trans } = useTranslation();
  return (
    <div
      className={`${className}`}
      style={style}
    >
      <Tooltip title={trans('table')}>
        <img src="/wagon-icons/table.png" width={46} height={46} className="object-center" alt="table" />
      </Tooltip>
    </div>
  );
}

export default WagonTable;
